<template>
  <div>
    <div class="f-search-block">
      <div class="search-items">
        <div class="field-item">
          <div class="field-item-control">
            <el-input
              v-model="keyword"
              class="name-mobile-input"
              placeholder="请输入内容"
            >
              <el-select
                slot="prepend"
                v-model="keywordType"
                style="width: 120px"
                placeholder="请选择"
                size="small"
              >
                <el-option
                  v-for="(item, index) in keyWordMap"
                  :key="index"
                  :label="item"
                  :value="index"
                />
              </el-select>
            </el-input>
          </div>
          <div class="field-item-control">
            <SpSearchGroup
              :clear-value="clearValue"
              @changeGroup="changeGroup"
            />
          </div>
          <div class="search-btns">
            <el-button
              type="primary"
              @click="haddleSearch"
            >
              查询
            </el-button>
            <el-button
              type="primary"
              @click="onReset"
            >
              重置
            </el-button>
          </div>
          <div class="tips">
            销售店铺数据由云店提供，实时同步
          </div>
        </div>
      </div>
    </div>
    <div class="f-table-block">
      <el-table
        v-loading="loading"
        :data="listData"
        row-key="id"
        default-expand-all
      >
        <el-table-column
          prop="store_name"
          label="店铺名称"
        />
        <el-table-column
          prop="store_bn"
          label="店铺编号"
        />
        <el-table-column
          prop="group_path_name"
          label="所属群组"
        />
        <el-table-column
          prop="address"
          label="店铺地址"
        />
        <el-table-column
          label="操作"
          width="220px"
        >
          <template slot-scope="scope">
            <el-button
              type="text"
              size="small"
              @click="changeOrganization(scope.row)"
            >
              变更群组
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        class="table-pagination"
        background
        :current-page="params.page"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="params.page_size"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total_count"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </div>

    <!-- 变更群组 -->
    <SpGroupsSelect
      v-model="groupsSelectVisible"
      :selected-id="selectedId"
      @chooseStore="chooseStore"
    />
  </div>
</template>

<script>
export default {
  data () {
    const keyWordMap = {
      'store_name': '店铺名称',
      'store_bn': '店铺编号'
    }
    return {
      keyWordMap,
      keywordType: 'store_name',
      keyword: '',
      listData: [],
      params: {
        page: 1,
        page_size: 10,
        group_code: null
      },
      total_count: 0,
      loading: false,
      groupsSelectVisible: false,
      editOrganization: {},
      clearValue: false,
      selectedId: ''
    }
  },
  mounted () {
    this.getList()
  },
  methods: {
    // 获取列表数据
    async getList () {
      const params = { ...this.params }
      const { keywordType, keyword } = this
      params[keywordType] = keyword
      const data = await this.$api.organization.getStoreList(params)
      if (data) {
        this.listData = data.list
        this.total_count = data.total_count
      }
    },
    // 查询
    haddleSearch () {
      this.params.page = 1
      this.getList()
    },
    // 分页
    handleSizeChange (val) {
      this.params.page = 1
      this.params.page_size = val
      this.getList()
    },
    handleCurrentChange (val) {
      this.params.page = val
      this.getList()
    },

    // 变更群组
    changeOrganization (val) {
      console.log(val)
      if (val.rel_group_path) {
        let codePath = val.rel_group_path.split(',')
        this.selectedId = codePath[codePath.length - 2]
      }
      this.editOrganization = val
      this.groupsSelectVisible = true
    },

    // 选择群组绑定
    async chooseStore (list) {
      if (list.group_code) {
        const data = await this.$api.organization.storeBindGroup({
          group_code: list.group_code,
          store_bns: this.editOrganization.store_bn
        })
        if (data) {
          this.$message.success('变更成功')
          this.groupsSelectVisible = false
          this.getList()
        }
      } else {
        this.$message.error('请选择群组')
      }
    },

    // 群组查询
    changeGroup (val) {
      this.clearValue = false
      if (val && val.length > 0) {
        this.params.group_code = val[val.length - 1]
      } else {
        this.params.group_code = null
      }
    },

    // 重置
    onReset () {
      this.params = {
        page: 1,
        page_size: 10,
        group_code: null
      }
      this.keywordType = 'store_name'
      this.keyword = ''
      this.clearValue = true
      this.haddleSearch()
    }
  }
}
</script>

<style lang="scss" scoped>
.search-btns {
  margin-right: 10px;
}
.field-item-control {
  margin-right: 15px;
}
.tips {
  font-size: 12px;
  color: #909399;
}
</style>
